export const HERO_ABILITY_UNLOCKS = {
  common: [],
  uncommon: [],
  rare: ["special_1"],
  epic: ["special_1", "special_2"],
  legendary: ["special_1", "special_2", "ultimate"],
};

export function abilitiesForRarity(abilities, rarity) {
  const slots =
    HERO_ABILITY_UNLOCKS[String(rarity || "").toLowerCase()] ||
    HERO_ABILITY_UNLOCKS.common;
  const source =
    abilities && typeof abilities === "object" && !Array.isArray(abilities)
      ? abilities
      : {};
  const out = {};
  for (const key of slots) {
    const ability = source[key];
    if (!ability?.name) continue;
    out[key] = {
      name: ability.name,
      description: ability.description || "",
    };
  }
  return out;
}
